$(document).ready(function () {

    var carousel = $('.owl-carousel');

    carousel.owlCarousel({
        loop: true,
        margin: 20,
        items: 1,
        smartSpeed: 1000,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true
    });
    $('#js-prev').click(function () {
        carousel.trigger('prev.owl.carousel');
        return false;
    });
    $('#js-next').click(function () {
        carousel.trigger('next.owl.carousel');
        return false;
    });

    $('.menu-wrapper').on('click', function () {
        $('.hamburger-menu').toggleClass('animate');
        $('.phone-menu').toggleClass('phone-menu-active');
        $('body').toggleClass('no-scroll');
    });

    $('.phone-menu').on('click', function () {
        $('.hamburger-menu').toggleClass('animate');
        $('.phone-menu').toggleClass('phone-menu-active');
        $('body').toggleClass('no-scroll');
    });
});